// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1FS9j","title":"Info_title__1KyvB","selects":"Info_selects__2Owjj","requiredAsterisk":"Info_requiredAsterisk__2X9pW"};